<template>
  <MetricTile
    v-if="density === 'default'"
    :loading="loading"
    :no-data="!metric || !metric.completed"
    :show-duration="false"
    icon="fa-solid fa-face-smile"
    :progress-bar-value="metric?.percentage"
    color="pink"
  >
    <template #title>Personality Trait Complete</template>
    <template #metric-title>Students</template>
    <template #metric>{{ metric.completed }}</template>
    <template #overMetric>{{ metric.total }}</template>
    <template #additionalMetric> {{ metric.percentage }}%</template>
  </MetricTile>
  <MiniMetricTile v-else-if="density === 'compact'" color="pink" :loading="loading">
    <template #icon>
      fa-solid fa-user-plus
    </template>
    <template #metric>
      {{ metric?.completed || 0 }}
    </template>
    <template #title>
      Personality Trait Complete
    </template>
  </MiniMetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
import MiniMetricTile from "@/components/Metrics/MiniMetricTile.vue";
import {PropType} from "vue";
const { metric, loading } = useMetricTile<
  {
    completed: number;
    total: number;
    percentage: number;
    count: number;
  }>("users-completed-big5-ratio");

defineProps({
  density: {
    type: String as PropType<"default" | "compact" | "comfortable">,
    default: "default"
  },
});
</script>
